import { Outlet } from 'react-router';
import { Toaster } from '../components/ui/sonner';
import { QuickNav } from '../components/QuickNav';

export default function RootLayout() {
  return (
    <>
      <Outlet />
      <Toaster />
      <QuickNav />
    </>
  );
}
